import React from 'react';
import './Button.scss';

type Props = {
  text: string;
  type?: 'orange' | 'grey' | 'light-grey' | 'link' | 'mid-grey';
  size?: 'sm' | 'lg' | 'stretch' | 'md';
  disabled?: boolean;
  shape?: 'square' | 'chamfer';
  onClick?: () => void;
};

const Button = (props: Props) => {
  const {
    text = '',
    disabled = false,
    size = 'lg',
    type = 'orange',
    shape = 'rounded',
    onClick = () => { },
  } = props;
  let finalCssClass = '';
  switch (type) {
    case 'grey':
      finalCssClass = 'lw-button-grey';
      break;
    case 'light-grey':
      finalCssClass = 'lw-button-light-grey';
      break;
    case 'mid-grey': 
      finalCssClass = 'lw-button-mid-grey';
      break;
    case 'link':
      finalCssClass = 'lw-button-link';
      break;
    default:
      finalCssClass = 'lw-button-orange';
      break;
  }

  switch (shape) {
    case 'square':
      finalCssClass += ' lw-button-square';
      break;
    case 'chamfer':
      finalCssClass += ' lw-button-chamfer';
      break;
  }

  switch (size) {
    case 'sm':
      finalCssClass += ' lw-button-sm';
      break;
    case 'stretch':
      finalCssClass += ' lw-button-stretch';
      break;
    case 'md':
      finalCssClass += ' lw-button-md';
      break;
    default:
      finalCssClass += ' lw-button-lg';
      break;
  }

  if (disabled) {
    finalCssClass += ' lw-button-disabled';
  }

  const innerOnClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <button className={`lw-button ${finalCssClass}`} onClick={innerOnClick}>
      {text}
    </button>
  );
};

export default Button;
